/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function UnknownCc(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'UnknownCc',
      'aria-hidden': true,
      focusable: false,
      width:  100 * scale,
      height: 60 * scale,
      viewBox: '0 0 100 60',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('rect', {"width":"100","height":"60","fill":"#D9D9D9","fillRule":"nonzero","rx":"4"}),createElement('rect', {"width":"20","height":"20","x":"70","y":"20","fill":"#A6A6A6","rx":"10"}),createElement('path', {"fill":"#A6A6A6","d":"m21 21 11 18H10zm20 0h18v18H41z"})))
}
